import { render, staticRenderFns } from "./view-item-file.vue?vue&type=template&id=63ab021e&"
import script from "./view-item-file.vue?vue&type=script&lang=js&"
export * from "./view-item-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports